import { ChevronRight } from 'lucide-react';

import { PortalRenderer } from '@/components/PortalRenderer';
import { useConfigStore } from '@/store/ConfigStore';
import { useSearchStore } from '@/store/SearchStore';

export const RouteSelection = () => {
  const portalSelector = useConfigStore((state) => state.portals?.['route-selection']);
  const { directions, locationSearch, searching, selectedRoute } = useSearchStore();

  if (!directions || locationSearch || searching || selectedRoute) return null;

  return (
    <PortalRenderer portalSelector={portalSelector}>
      <RouteSelectionInternal />
    </PortalRenderer>
  );
};

const RouteSelectionInternal = () => {
  const { directions, locationStart, locationEnd, locationSearch, searching, selectedRoute, setSelectedRoute } =
    useSearchStore();

  if (!directions || !locationStart || !locationEnd || locationSearch || searching || selectedRoute) return null;

  const { routes } = directions;

  return (
    <div className="flex flex-col gap-4">
      {routes.map((route, index) => (
        <div
          key={index}
          role="button"
          tabIndex={0}
          aria-label={`Select route: ${route.airQuality?.label_ranking} pollution, ${route.airQuality?.label_duration} duration, ${route.airQuality?.label_distance} distance`}
          className="focus-visible:outline-border flex h-20 cursor-pointer items-center overflow-clip rounded shadow-md hover:shadow-lg focus-visible:outline-4 dark:bg-white/5 dark:shadow-lg dark:hover:shadow-2xl"
          onMouseDown={() => setSelectedRoute(route)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              setSelectedRoute(route);
            }
          }}
        >
          <div style={{ backgroundColor: route.airQuality?.color }} className="mr-4 h-full w-1"></div>
          <div className="flex flex-col gap-2">
            <div className="text-[var(--blue-one)] underline underline-offset-4 dark:text-white">
              {route.airQuality?.label_ranking} • {route.airQuality?.label_duration}&nbsp;(
              {route.airQuality?.label_distance})
            </div>
            {route.airQuality?.in_modelled_area === 'Y' && (
              <div className="dark:opacity-50">
                NO2 {route.airQuality?.no2?.toFixed(1)} µg h/m3 • PM2.5 {route.airQuality?.['pm2.5']?.toFixed(1)} µg
                h/m3
              </div>
            )}
          </div>
          <div className="relative mr-2 ml-auto flex w-5.5 items-center justify-center">
            <ChevronRight className="text-[var(--blue-one)] dark:text-white" />
          </div>
        </div>
      ))}
    </div>
  );
};
